// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TreeNode  {
    _originalTypeClassName = "Loom.BO.TreeNode";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TreeNode.translate = translateService;
}
this.children = [];
this.label = null;
this.expanded = false;
this.info = null;
this.key = null;
this.leaf = false;
this.style = null;
this.wp_id = null;
this.task_id = null;
this.subtask_id = null;
this.TreeNodeKey = null;
this._key = this.TreeNodeKey = 0; 
}

static translate: TranslateService;
_key: any;
label:any;
expanded:any;
info:any;
key:any;
leaf:any;
style:any;
wp_id:any;
task_id:any;
subtask_id:any;
parent:any;
children:any;
private _TreeNodeKey:any;
get TreeNodeKey(): any {
    return this._TreeNodeKey;
  }
set TreeNodeKey(value: any) {
    this._TreeNodeKey = value;
    this._key = value;
  }
static setparent = ($this, value) => {
var oldValue = $this.parent;
$this.parent = value;
if (value != null) {
if (oldValue != null) {
Domain.TreeNode.removechildren(oldValue, $this);
}
Domain.TreeNode.addchildren(value, $this);
}
}
static setchildren = ($this, items) => {
                if (items == null) items = [];
                if ($this.children == null) $this.children = [];

                const copyItems = Common.cloneObject(items);

                while ($this.children.length > 0) {
                    Domain.TreeNode.removechildren($this, $this.children[0]);
                }

                Domain.TreeNode.addManychildren($this, copyItems);
            }
static addManychildren = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TreeNode.addchildren($this, items[i]);
                }
            }
static addchildren = ($this, item) => {
                if ($this.children == null) $this.children = [];
                if (item == null || $this.children.indexOf(item) > -1) return;
                $this.children.push(item);
if (item.parent != $this) {
Domain.TreeNode.setparent(item, $this);
}
}
static addRangechildren = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TreeNode.addchildren($this, item));
            }
static removechildren = ($this, item) => {
                if ($this == null || $this.children == null || $this.children.indexOf(item) === -1) return;
                var _index = $this.children.indexOf(item);
                $this.children.splice(_index, 1);
item.parent = null;
}
static clearchildren = ($this) => { $this.children = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TreeNodeKey == null || $this.TreeNodeKey == 0;
            }


}